import { render, staticRenderFns } from "./req_list.vue?vue&type=template&id=50c90e45&"
import script from "./req_list.vue?vue&type=script&lang=js&"
export * from "./req_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports